module.exports = __webpack_public_path__ + "img/two-step-success.0cb3b7c8.svg";